import { BasePageProps, BasePageState, basePageInitialState } from '../BasePage'

import { InsuranceDataStatus, baseInsuranceDataInitialStatus } from '../../components/insurance/StatusSlice'
import { VehicleStatus, baseVehicleInitialStatus } from '../../components/vehicle/VehicleSlice'

import { store } from '../../redux/store'

import { createReducer, createAction } from '@reduxjs/toolkit'

export interface MicroCarProps extends BasePageProps {}

type MicroCarState = VehicleStatus & InsuranceDataStatus

export type MicroCarPageState = MicroCarState & BasePageState

export const microInitialState : MicroCarPageState = {
    ...basePageInitialState,
    ...baseVehicleInitialStatus,
    ...baseInsuranceDataInitialStatus,
    // sovrascrivo i valori dedotti assegnado il valore di defaut
    ...{
        altriSinistri: false,
        polizzaAttiva: false
    }
}

export const microcarUpdate = createAction<MicroCarPageState>('microcar/update')

export const microcarReducer = createReducer ( 
    microInitialState,
    (builder) => {
        builder.addCase(microcarUpdate, (state, action) => {
            return action.payload as MicroCarPageState
        })
    }
)

export type MicroCarRootState = ReturnType<typeof store.getState>
export type MicroCarDispatch = typeof store.dispatch